import { call, put } from 'redux-saga/effects';
import { BACKEND_URL, FRONT_URL } from '../../../configs';
import {
  authorizedESIALoginFailed,
  authorizedESIALoginSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';

export default function* authorizedESIALogin(action) {
  try {
    const url = `${BACKEND_URL}/auth/trust-gate/get-redirect-url`;
    const dataResponse = yield makeRequest(url, {
      redirect_url: `${FRONT_URL}/esia-callback`,
    }, action, 'GET', true);
    const data = yield dataResponse?.json();
    if (dataResponse?.status === OK) {
      yield put(authorizedESIALoginSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(authorizedESIALoginFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(authorizedESIALoginFailed(e));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
